import { storageProvider } from '@ocean/configs'

const ONBOARDING_VIEWED = 'ONBOARDING_VIEWED'

// Onboarding visibility needed for page refresh and direct links
class OnboardingUtils {
  viewed = 'VIEWED'

  markOnboardingViewed() {
    storageProvider.setItem(ONBOARDING_VIEWED, this.viewed)
  }

  clearOnboardingViewed() {
    storageProvider.removeItem(ONBOARDING_VIEWED)
  }

  getOnboardingState() {
    return storageProvider.getItem(ONBOARDING_VIEWED)
  }
}

export default new OnboardingUtils()
